(function () {
    'use strict';

    function init() {
        setupSwiper('.js-logo-carousel', {
            containerSelector: '.js-logo-carousel-container',
            jsSelector: '.js-logo-carousel',
            swiperOptions: {
                slidesPerView: 'auto',
                spaceBetween: -1,
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();